module.exports = __webpack_public_path__ + "img/ic_notifications.1d02b76f.svg";